import React from 'react'
import Redirector from '../../bundles/GuestSignUp/routes/Redirector'
import ButtonGroup from '../../bundles/GuestSignUp/components/ButtonGroup'
import { setPreviousPage } from '../actions'
import { useDispatch } from 'react-redux';

export default ({ page, thisPage, back, skip, submitFunc, disableSubmit, children }) => (
  <div id={thisPage} className='profile'>
    <Redirector this_page={thisPage} page={page}/>
    <form>
      {children}
      <ButtonGroup
        back={back}
        skip={skip}
        submitFunc={submitFunc}
        page={thisPage}
        disableSubmit={disableSubmit} />
    </form>
  </div>
)
